export const CONFIRM_YOUR_VEHICLE_MODAL = 'confirmYourVehicle'

export const INPUT_RADIO_NAME = 'confirmYourVehicleRadioInput'
